import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthservicesService } from 'src/app/services/authservices.service';

@Component({
  selector: 'app-others-profile',
  templateUrl: './others-profile.component.html',
  styleUrls: ['./others-profile.component.css']
})
export class OthersProfileComponent implements OnInit {
  communityID
  communityData
  loading = false
  constructor(private authService: AuthservicesService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.communityID = params["id"];
    });

    this.communityDetail();

  }
  communityDetail() {
    this.authService.communitydetails(this.communityID).subscribe((res: any) => {
      this.loading = true
      this.communityData = res.data
    },
      error => {
        console.log(error)
      })
  }


}
